// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__nxRYE","checked":"Checkbox_checked__4wW5X"};